import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { COLORES } from '../../../config/colores'
import { Dialog, Button, Tooltip } from '@material-ui/core'
import DialogView from '../../Dialogos/DialogView'
import InfoIcon from '@material-ui/icons/Info'
import CantidadProductosPorCereal from './reporteCamiones/CantidadProductosPorCereal'
import TablaCamionesListosParaBruto from '../../Camiones/containers/listados/camionesListosParaBruto/containers/TablaCamionesListosParaBruto'
import DialogoPedidoCamiones from '../../Pesado/components/bruto/DialogoPedidoCamiones'
import InfoAutodescargables from './reporteCamiones/InfoAutodescargables'
import { updateActualizacionHabilitada } from '../../Pesado/actions'
import PedidosPendientes from '../../Pesado/components/bruto/PedidosPendientes'

function ReporteListosParaBruto (props) {
  const { camListosParaBruto, dialogOpen = null, roles } = props
  const [open, setOpen] = useState(false)
  const [openPedidos, setOpenPedidos] = useState(false)
  const [totalProductos, setTotalProductos] = useState(null)
  const [autodescargables, setAutodescargables] = useState([])
  const [productosPorCereal, setProductosPorCereal] = useState([])
  const [calificacionProductos, setCalificacionProductos] = useState([])

  useEffect(() => {
    function setUp () {
      if (camListosParaBruto.length > 0) {
        const total = camListosParaBruto.length
        setTotalProductos(total)

        const camAutodescargables = camListosParaBruto.filter((c) => c.autodescargable)

        const productos = []
        const calificaciones = []
        const productosListos = camListosParaBruto.reduce((prod, camion) => {
          const { claveCereal, calificacionCereal } = camion
          const productoExistente = productos.find(producto => producto.cereal === claveCereal)
          const existeCalificacion = calificaciones.find(c => c.cereal === claveCereal && c.calificacion === calificacionCereal)

          if (!existeCalificacion && calificacionCereal) {
            const cantidadCalificacion = camListosParaBruto.filter((p) => p.claveCereal === claveCereal && p.calificacionCereal === calificacionCereal)
            calificaciones.push({ cereal: claveCereal, calificacion: calificacionCereal, cantidad: cantidadCalificacion.length })
          }

          if (!productoExistente) {
            const cantidad = camListosParaBruto.filter((p) => p.claveCereal === claveCereal)
            productos.push({ cereal: claveCereal, cantidad: cantidad.length })
          }

          return productos
        }, [])
        setCalificacionProductos(calificaciones)
        setProductosPorCereal(productosListos)
        setAutodescargables(camAutodescargables)
        productosListos.sort((a, b) => {
          return a.cereal.localeCompare(b.cereal)
        })
      }
    }

    setUp()
  }, [camListosParaBruto])

  const handleClose = () => {
    setOpen(false)
    if (dialogOpen) { dialogOpen(true) }
  }

  const handleOpen = () => {
    setOpen(true)
    if (dialogOpen) { dialogOpen(true) }
  }

  const handleOpenPedidos = () => {
    setOpenPedidos(true)
    props.updateActualizacionHabilitada(false)
  }

  const handleClosePedidos = () => {
    setOpenPedidos(false)
    props.updateActualizacionHabilitada(true)
  }

  const detalleProductos = () => {
    if (calificacionProductos.length > 0) {
      return (
        <div>
          <Tooltip title={<>
            <h6>Productos condicionales</h6>
            { calificacionProductos.map((c, i) => {
              return (
                <div key={i}>
                  <b>{c.cereal}</b> - {c.calificacion} : <b>{c.cantidad}</b>
                </div>
              )
            })}
          </>
          }
          >

            <InfoIcon style={{ color: COLORES.grey.dark, margin: '0 8px' }} />
          </Tooltip>
        </div>
      )
    } else {
      return null
    }
  }

  const contenidoAutodescargables = () => {
    const filtroInicial = [
      {
        name: 'autodescargable',
        filterList: ['Si']
      }
    ]

    return <TablaCamionesListosParaBruto filtroInicial={filtroInicial} />
  }

  const rol = roles.filter(roles => roles === 'BALANCEROCAMIONES' || roles === 'DESARROLLADOR' || roles === 'SUPERVISOR')
  const rolAutorizado = rol.length > 0

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='xl'
      >
        <DialogView
          cancelCallback={handleClose}
          title='Camiones listos para bruto'
          content={<TablaCamionesListosParaBruto />}
        />
      </Dialog>

      <CantidadProductosPorCereal
        productosPorCereal={productosPorCereal}
        titulo='Listos para bruto'
        tituloTotal='Total'
        totalProductos={totalProductos}
        detalleProductos={detalleProductos}
      />

      { autodescargables &&
        <InfoAutodescargables
          productos={autodescargables}
          contenido={contenidoAutodescargables}
          titulo='Camiones autodescargables listos para bruto'
        />
      }

      <DialogoPedidoCamiones open={openPedidos} handleClose={handleClosePedidos} />

      <PedidosPendientes />

      <div>
        {rolAutorizado &&
          <Button
            size='small'
            className='btn-reportes-bruto'
            variant='contained'
            style={{ color: 'white', backgroundColor: COLORES.violet, borderRadius: '22px', margin: '8px auto' }}
            onClick={handleOpenPedidos}
          >

            Pedidos de camiones
          </Button>
        }
        <Button
          size='small'
          className='btn-reportes-bruto'
          variant='contained'
          style={{ color: '#ffffff', backgroundColor: COLORES.grey.dark, borderRadius: '22px', margin: '0 auto' }}
          onClick={handleOpen}
        >

                  Listos para bruto
        </Button>
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  camListosParaBruto: state.camionesIngreso.camListosParaBruto,
  camionesPedidos: state.pesado.camionesPedidosBruto,
  roles: state.auth.roles
})

const mapActionsToProps = {
  updateActualizacionHabilitada
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(ReporteListosParaBruto)
